import { Button, IButtonBusinessLogic, IButtonProperties, createButton } from '@vfde-brix/ws10/button';
import { HtmlId } from '../enums/elementId';
import { getAvcResultButtonProps } from 'Container/AvailabilityCheck/util/result';
import { getUpdatedPriceButtonProps } from '../util/components/buttonHelper';
import { mountComponent } from '../util/mount';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { AvcResult, JarvisProduct } from '@vfde-sails/avc-core';
import { HomesPassedType } from '../enums/product';
import { showElement } from '../util/visibility';

/**
 * Create Brix button component.
 * @param wrapperId - ID of the button element.
 * @param onClick - OnClick event handler.
 * @returns Mounted button component or undefined if the element can't be found with the provided wrapperId.
 *
 */
export const mountButton = (wrapperId: HtmlId, onClick?: Function) => {
    const props: IButtonProperties | IButtonBusinessLogic = onClick
        ? {
            onClick: (e: Event) => {
                e.preventDefault();
                onClick();
            },
        }
        : NO_PATTERN_BUSINESS_LOGIC;

    return mountComponent(wrapperId, createButton, props);
};

/**
 * Update the avc result button.
 * @param comp - Mounted button element
 * @param tariffId - Id of the selected tariff
 * @param product - Fastest available product
 */
export const updateAvcResultButton = (
    comp: Button | undefined,
    tariffId: string,
    isPreFiber: boolean,
    product?: JarvisProduct,
    homesPassedType?: HomesPassedType,
) => {
    const isBHS = homesPassedType === HomesPassedType.BHS;

    comp && showElement(comp.getContainerElement(), !isBHS);

    if (isBHS) {
        return;
    }

    comp?.update(getAvcResultButtonProps(tariffId, isPreFiber, product));
};

/**
 * Update the price button.
 * @param comp - Mounted button element.
 * @param tariffId - Id of the selected tariff
 * @param avcResult - Result of the avc, if there is.
 * @param onClick - OnClick event.
 */
export const updatePriceButton = (
    comp: Button | undefined,
    tariffId: string | undefined,
    avcResult?: AvcResult,
    onClick?: () => void,
    isPreFiber?: boolean,
    homesPassedType?: HomesPassedType,
) => comp?.update(getUpdatedPriceButtonProps(tariffId, avcResult, onClick, isPreFiber, homesPassedType));
/**
 * Update the floating button.
 * @param floatingButton - Mounted button element.
 * @param tariffId - Id of the selected tariff
 * @param avcResult - Result of the avc, if there is.
 * @param onClick - OnClick event.
 */

export const updateFloatingButton = (floatingButton: Button | undefined,
    btnProps: IButtonProperties | undefined, tariffId: string | undefined,
    avcResult?: AvcResult,
    onClick?: () => void,
    isPreFiber?: boolean,): void => {
    if (!floatingButton || !btnProps) {
        return;
    }

    floatingButton.update(getUpdatedPriceButtonProps(tariffId, avcResult, onClick, isPreFiber));
};
